import {SpyneTrait, ViewStream} from 'spyne';
import { CodeBlockUtilsTraits } from "traits/code-block-utils-traits";

export class CodePlaygroundExamplesTemplatesClaudeTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "codeplaygroundTemplates$";

    super(context, traitPrefix);
  }

// =====================================================================
// codeplaygroundTemplates$ObjectAsConditional
//
// Demonstrates: {{#obj}}...{{/obj}} as a conditional wrapper for an
// optional sub-object. The eyebrow wrapper renders only when present.
// =====================================================================

  static codeplaygroundTemplates$RunObjectAsConditionalExample() {
    const data = {
      items: [
        { eyebrow: { label: "Chef's Pick" }, title: "Truffle Mac & Cheese",  body: "Aged gruyere, crispy shallots..." },
        {                                    title: "Margherita Pizza",      body: "San Marzano, fresh basil..."      },
        { eyebrow: { label: "Seasonal" },    title: "Peach Burrata Salad",   body: "Grilled peaches, hot honey..."    }
      ]
    };

    const template = `
    {{#items}}
      <section style="margin-bottom: 1.5rem;">
        {{#eyebrow}}<div class="eyebrow" style="margin:0">{{label}}</div>{{/eyebrow}}
        <h4 style="margin:0">{{title}}</h4>
        <p style="margin:0">{{body}}</p>
      </section>
    {{/items}}
  `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:block; flex-wrap:wrap; gap:1rem;",
      data,
      template
    };

    return new ViewStream(props);
  }

  static codeplaygroundTemplates$ObjectAsConditional() {
    const vs = this.codeplaygroundTemplates$RunObjectAsConditionalExample();
    vs.appendToDom(this.props.el.contentDocument.body);

    this.props.el.contentDocument.body.style["font-size"] = "14px";
    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
        [12],
        this.props.parentVsid,
    );

    return `
      const data = {
        items: [
          { eyebrow: { label: "Chef's Pick" }, title: "Truffle Mac & Cheese",  body: "Aged gruyere, crispy shallots..." },
          {                                    title: "Margherita Pizza",      body: "San Marzano, fresh basil..."      },
          { eyebrow: { label: "Seasonal" },    title: "Peach Burrata Salad",   body: "Grilled peaches, hot honey..."    }
        ]
      };


    const template = \`
      {{#items}}
        <section>
          {{#eyebrow}}<div class="eyebrow">{{label}}</div>{{/eyebrow}}
          <h4>{{title}}</h4>
          <p>{{body}}</p>
        </section>
      {{/items}}\`


    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data, template
    }


    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

  `;
  }


// =====================================================================
// codeplaygroundTemplates$BareArrayShorthand
//
// Demonstrates: when `data` IS an array (not an object containing an
// array), {{#}}...{{/}} iterates it directly with no outer key.
// =====================================================================

  static codeplaygroundTemplates$RunBareArrayShorthandExample() {
    const data = [
      { name: "Light Cobalt",    hex: "#ADCFFF" },
      { name: "Light Crimson",   hex: "#FFB3BA" },
      { name: "Goldenrod",       hex: "#DAA520" },
      { name: "Light Teal",      hex: "#99E6E6" },
      { name: "Light Indigo",    hex: "#C3B1E1" }
    ];

    const template = `
    {{#}}
      <div class="swatch" style="background:{{hex}};">
        <span>{{name}} <code>{{hex}}</code></span>
      </div>
    {{/}}
  `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:block; flex-wrap:wrap; gap:1rem;",
      data,
      template
    };

    return new ViewStream(props);
  }

  static codeplaygroundTemplates$BareArrayShorthand() {
    const vs = this.codeplaygroundTemplates$RunBareArrayShorthandExample();
    vs.appendToDom(this.props.el.contentDocument.body);

    this.props.el.contentDocument.body.style["font-size"] = "14px";
    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
        [10, 17],
        this.props.parentVsid,
    );

    return `
    const data = [
      { name: "Light Cobalt",    hex: "#ADCFFF" }, 
      { name: "Light Crimson",   hex: "#FFB3BA" }, 
      { name: "Goldenrod",       hex: "#DAA520" }, 
      { name: "Light Teal",      hex: "#99E6E6" }, 
      { name: "Light Indigo",    hex: "#C3B1E1" } 
    ];


    const template = \`
      {{#}}
        <div class="swatch" style="background:{{hex}};">
          <span>{{name}} <code>{{hex}}</code></span>
        </div>
      {{/}}\`


    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data, template
    }


    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

  `;
  }


// =====================================================================
// codeplaygroundTemplates$NestedArrayLoop
//
// Demonstrates: one level of nested array iteration.
// {{#cells}} works inside {{#rows}}.
// =====================================================================

  static codeplaygroundTemplates$RunNestedArrayLoopExample() {
    const data = {
      headers: ["Region", "Q3", "Q4", "Total"],
      rows: [
        { cells: ["North", "1,240", "1,580", "2,820"] },
        { cells: ["South", "980",   "1,210", "2,190"] },
        { cells: ["East",  "1,640", "1,720", "3,360"] },
        { cells: ["West",  "1,120", "1,340", "2,460"] }
      ]
    };

    const template = `
    <table>
      <thead>
        <tr>{{#headers}}<th>{{.}}</th>{{/headers}}</tr>
      </thead>
      <tbody>
        {{#rows}}
          <tr>{{#cells}}<td>{{.}}</td>{{/cells}}</tr>
        {{/rows}}
      </tbody>
    </table>
  `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif;",
      data,
      template
    };

    return new ViewStream(props);
  }

  static codeplaygroundTemplates$NestedArrayLoop() {
    const vs = this.codeplaygroundTemplates$RunNestedArrayLoopExample();
    vs.appendToDom(this.props.el.contentDocument.body);

    this.props.el.contentDocument.body.style["font-size"] = "14px";
    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
        [16, 17, 18],
        this.props.parentVsid,
    );

    return `
    const data = {
      headers: ["Region", "Q3", "Q4", "Total"],
      rows: [
        { cells: ["North", "1,240", "1,580", "2,820"] },
        { cells: ["South", "980",   "1,210", "2,190"] },
        { cells: ["East",  "1,640", "1,720", "3,360"] },
        { cells: ["West",  "1,120", "1,340", "2,460"] }
      ]
    };


    const template = \`
      <table>
        <thead>
          <tr>{{#headers}}<th>{{.}}</th>{{/headers}}</tr>
        </thead>
        <tbody>
          {{#rows}}
            <tr>{{#cells}}<td>{{.}}</td>{{/cells}}</tr>
          {{/rows}}
        </tbody>
      </table>\`


    const props = {
      tagName: "article",
      style: "font-family:sans-serif;",
      data, template
    }


    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

  `;
  }


// =====================================================================
// codeplaygroundTemplates$PositionalTokens
//
// Demonstrates: {{loopIndex}} (0-based) and {{loopNum}} (1-based)
// auto-injected inside every array section.
// =====================================================================

  static codeplaygroundTemplates$RunPositionalTokensExample() {
    const data = {
      steps: [
        { title: "Initialize SpyneApp",       note: "Call SpyneApp.init() before anything else." },
        { title: "Register channels",         note: "Add CHANNEL_UI, CHANNEL_ROUTE, and any custom channels." },
        { title: "Mount the root ViewStream", note: "Render the application's top-level View." }
      ]
    };

    const template = `
    <ol class="steps">
      {{#steps}}
        <li>
          <div class="marker">{{loopNum}}</div>
          <div class="content">
            <div class="title">{{title}}</div>
            <div class="note">{{note}} <span class="index">(index {{loopIndex}})</span></div>
          </div>
        </li>
      {{/steps}}
    </ol>
  `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif; max-width:480px;",
      data,
      template
    };

    return new ViewStream(props);
  }

  static codeplaygroundTemplates$PositionalTokens() {
    const vs = this.codeplaygroundTemplates$RunPositionalTokensExample();
    vs.appendToDom(this.props.el.contentDocument.body);

    this.props.el.contentDocument.body.style["font-size"] = "14px";
    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
        [16, 19],
        this.props.parentVsid,
    );

    return `
    const data = {
      steps: [
        { title: "Initialize SpyneApp",       note: "Call SpyneApp.init() before anything else." },
        { title: "Register channels",         note: "Add CHANNEL_UI, CHANNEL_ROUTE, and any custom channels." },
        { title: "Mount the root ViewStream", note: "Render the application's top-level View." }
      ]
    };


    const template = \`
      <ol class="steps">
        {{#steps}}
          <li>
            <div class="marker">{{loopNum}}</div>
            <div class="content">
              <div class="title">{{title}}</div>
              <div class="note">{{note}} <span>(index {{loopIndex}})</span></div>
            </div>
          </li>
        {{/steps}}
      </ol>\`


    const props = {
      tagName: "article",
      style: "font-family:sans-serif;",
      data, template
    }


    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

  `;
  }


}

